var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44007 25.8467L3.4134 25.8733C3.0534 25.0867 2.82673 24.1933 2.7334 23.2067C2.82673 24.18 3.08007 25.06 3.44007 25.8467Z",
    fill: "#908880"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.34C13.7526 14.34 15.1733 12.9192 15.1733 11.1667C15.1733 9.41408 13.7526 7.99333 12 7.99333C10.2474 7.99333 8.82666 9.41408 8.82666 11.1667C8.82666 12.9192 10.2474 14.34 12 14.34Z",
    fill: "#908880"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5865 3.16667H10.4132C5.55984 3.16667 2.6665 6.06 2.6665 10.9133V22.0867C2.6665 23.54 2.91984 24.8067 3.41317 25.8733C4.55984 28.4067 7.01317 29.8333 10.4132 29.8333H21.5865C26.4398 29.8333 29.3332 26.94 29.3332 22.0867V19.0333V10.9133C29.3332 6.06 26.4398 3.16667 21.5865 3.16667ZM27.1598 17.1667C26.1198 16.2733 24.4398 16.2733 23.3998 17.1667L17.8532 21.9267C16.8132 22.82 15.1332 22.82 14.0932 21.9267L13.6398 21.5533C12.6932 20.7267 11.1865 20.6467 10.1198 21.3667L5.13317 24.7133C4.83984 23.9667 4.6665 23.1 4.6665 22.0867V10.9133C4.6665 7.15334 6.65317 5.16667 10.4132 5.16667H21.5865C25.3465 5.16667 27.3332 7.15334 27.3332 10.9133V17.3133L27.1598 17.1667Z",
    fill: "#908880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.a84e80c7264ecdc7d434fe7a5cc7f8ca.svg";
export { ForwardRef as ReactComponent };